module.exports = [
    {
        value: '01',
        label: 'Individual – Resident who does not carry on business'
    },
    {
        value: '02',
        label: 'Self-employed or Business'
    },
    {
        value: '03',
        label: 'Partnership'
    },
    {
        value: '04',
        label: 'Private Company (Sdn Bhd)'
    },
    {
        value: '05',
        label: 'Hindu Joint Family'
    },
    {
        value: '06',
        label: 'Association'
    },
    {
        value: '07',
        label: 'Deceased Person\'s Estate'
    },
    {
        value: '08',
        label: 'Trust Body'
    },
    {
        value: '09',
        label: 'Unit/Real Property Trust'
    },
    {
        value: '10',
        label: 'Co-Operative Society'
    },
    {
        value: '11',
        label: 'Real Estate Investment Trust / Property Trust Fund'
    },
    {
        value: '12',
        label: 'Limited Liability Partnership'
    },
    {
        value: '13',
        label: 'Business Trust'
    },
    {
        value: '14',
        label: 'Labuan Entity'
    }
];



// WEBPACK FOOTER //
// ./app/employer/views/settings/CompanyTypes.js